export default __webpack_public_path__ + "static/media/Icon-ParentalLeave.cac2a47a.svg";